export default function classNames(...args) {
    const classes = [];
    for (let i = 0; i < args.length; i++) {
        const value = args[i];
        if (!value) continue;
        if (typeof value === 'string') {
            classes.push(value);
        } else if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
                const inner = classNames(value[i]);
                if (inner) {
                    classes.push(inner);
                }
            }
        } else if (typeof value === 'object') {
            for (const name in value) {
                if (value[name]) {
                    classes.push(name);
                }
            }
        }
    }
    return classes.join(' ');
}
